import _defineProperty from "/usr/src/app/www/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/usr/src/app/www/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/usr/src/app/www/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/usr/src/app/www/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _regeneratorRuntime from "/usr/src/app/www/node_modules/@babel/runtime/regenerator/index.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { importJWK } from '../key/import.js';
import { JWKSInvalid, JOSENotSupported, JWKSNoMatchingKey, JWKSMultipleMatchingKeys } from '../util/errors.js';
import isObject from '../lib/is_object.js';
function getKtyFromAlg(alg) {
  switch (typeof alg === 'string' && alg.slice(0, 2)) {
    case 'RS':
    case 'PS':
      return 'RSA';
    case 'ES':
      return 'EC';
    case 'Ed':
      return 'OKP';
    default:
      throw new JOSENotSupported('Unsupported "alg" value for a JSON Web Key Set');
  }
}
export function isJWKSLike(jwks) {
  return jwks && typeof jwks === 'object' && Array.isArray(jwks.keys) && jwks.keys.every(isJWKLike);
}
function isJWKLike(key) {
  return isObject(key);
}
function clone(obj) {
  if (typeof structuredClone === 'function') {
    return structuredClone(obj);
  }
  return JSON.parse(JSON.stringify(obj));
}
export var LocalJWKSet = /*#__PURE__*/function () {
  function LocalJWKSet(jwks) {
    _classCallCheck(this, LocalJWKSet);
    this._cached = new WeakMap();
    if (!isJWKSLike(jwks)) {
      throw new JWKSInvalid('JSON Web Key Set malformed');
    }
    this._jwks = clone(jwks);
  }
  _createClass(LocalJWKSet, [{
    key: "getKey",
    value: function () {
      var _getKey = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(protectedHeader, token) {
        var _protectedHeader$toke, alg, kid, kty, candidates, jwk, length, cached, keyObject;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _protectedHeader$toke = _objectSpread(_objectSpread({}, protectedHeader), token.header), alg = _protectedHeader$toke.alg, kid = _protectedHeader$toke.kid;
                kty = getKtyFromAlg(alg);
                candidates = this._jwks.keys.filter(function (jwk) {
                  var candidate = kty === jwk.kty;
                  if (candidate && typeof kid === 'string') {
                    candidate = kid === jwk.kid;
                  }
                  if (candidate && typeof jwk.alg === 'string') {
                    candidate = alg === jwk.alg;
                  }
                  if (candidate && typeof jwk.use === 'string') {
                    candidate = jwk.use === 'sig';
                  }
                  if (candidate && Array.isArray(jwk.key_ops)) {
                    candidate = jwk.key_ops.includes('verify');
                  }
                  if (candidate && alg === 'EdDSA') {
                    candidate = jwk.crv === 'Ed25519' || jwk.crv === 'Ed448';
                  }
                  if (candidate) {
                    switch (alg) {
                      case 'ES256':
                        candidate = jwk.crv === 'P-256';
                        break;
                      case 'ES256K':
                        candidate = jwk.crv === 'secp256k1';
                        break;
                      case 'ES384':
                        candidate = jwk.crv === 'P-384';
                        break;
                      case 'ES512':
                        candidate = jwk.crv === 'P-521';
                        break;
                    }
                  }
                  return candidate;
                });
                jwk = candidates[0], length = candidates.length;
                if (!(length === 0)) {
                  _context.next = 8;
                  break;
                }
                throw new JWKSNoMatchingKey();
              case 8:
                if (!(length !== 1)) {
                  _context.next = 10;
                  break;
                }
                throw new JWKSMultipleMatchingKeys();
              case 10:
                cached = this._cached.get(jwk) || this._cached.set(jwk, {}).get(jwk);
                if (!(cached[alg] === undefined)) {
                  _context.next = 18;
                  break;
                }
                _context.next = 14;
                return importJWK(_objectSpread(_objectSpread({}, jwk), {}, {
                  ext: true
                }), alg);
              case 14:
                keyObject = _context.sent;
                if (!(keyObject instanceof Uint8Array || keyObject.type !== 'public')) {
                  _context.next = 17;
                  break;
                }
                throw new JWKSInvalid('JSON Web Key Set members must be public keys');
              case 17:
                cached[alg] = keyObject;
              case 18:
                return _context.abrupt("return", cached[alg]);
              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function getKey(_x, _x2) {
        return _getKey.apply(this, arguments);
      }
      return getKey;
    }()
  }]);
  return LocalJWKSet;
}();
export function createLocalJWKSet(jwks) {
  return LocalJWKSet.prototype.getKey.bind(new LocalJWKSet(jwks));
}